const protoChatId = 'sinitic-webchat-wrapper';

export default protoChatId;
